import { render } from "./EditSessionNotesLayout.vue?vue&type=template&id=4dd8d1f4&scoped=true"
import script from "./EditSessionNotesLayout.vue?vue&type=script&lang=js"
export * from "./EditSessionNotesLayout.vue?vue&type=script&lang=js"

import "./EditSessionNotesLayout.vue?vue&type=style&index=0&id=4dd8d1f4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd8d1f4"]])

export default __exports__